import { Injectable, signal, inject } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from '../../environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SocketService {
    private socket: Socket | null = null;
    private invoiceUpdatedSubject = new Subject<any>();
    private notificationSubject = new Subject<any>();
    private businessLogSubject = new Subject<any>();

    // Señal para estado de conexión
    connected = signal<boolean>(false);

    constructor() {
        this.init();
    }

    private init() {
        // Extraer host de apiUrl (ej: http://localhost:3000)
        const url = new URL(environment.apiUrl);
        const socketUrl = `${url.protocol}//${url.host}/notifications`;

        this.socket = io(socketUrl, {
            autoConnect: true,
            reconnection: true
        });

        this.socket.on('connect', () => {
            console.log('Socket conectado:', this.socket?.id);
            this.connected.set(true);
        });

        this.socket.on('disconnect', () => {
            console.log('Socket desconectado');
            this.connected.set(false);
        });

        this.socket.on('invoice-updated', (data) => {
            console.log('Factura actualizada recibida vía Socket:', data);
            this.invoiceUpdatedSubject.next(data);
        });

        this.socket.on('notification', (data) => {
            console.log('Notificación de usuario recibida:', data);
            this.notificationSubject.next(data);
        });

        this.socket.on('business-log', (data) => {
            console.log('Log de negocio recibido:', data);
            this.businessLogSubject.next(data);
        });
    }

    /**
     * Se une a salas de negocio y/o usuario
     */
    joinRooms(data: { businessId?: string; establishmentId?: string; pointOfEmissionId?: string; userId?: string }) {
        if (!this.socket) return;
        this.socket.emit('join-room', data);
    }

    /**
     * Observables para suscripción a eventos
     */
    onInvoiceUpdated(): Observable<any> {
        return this.invoiceUpdatedSubject.asObservable();
    }

    onNotification(): Observable<any> {
        return this.notificationSubject.asObservable();
    }

    onBusinessLog(): Observable<any> {
        return this.businessLogSubject.asObservable();
    }

    /**
     * Desconecta el socket
     */
    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
        }
    }
}
